import { SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_DELAYED_REASONS_LIST } from 'api/utilityActionTypes';

export default async function getDelayedReasonsList(
  { state, utilityApiClient },
  { forceRefresh = false } = {},
) {
  const currentStatePath = ['utilityDelayedReasons', 'list'];
  if (!forceRefresh && state.get(currentStatePath)) {
    return state.get(currentStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_ITEM_GET_DELAYED_REASONS_LIST,
    state: state,
    onSuccess(delayedReasonsList) {
      if (delayedReasonsList) {
        state.set(currentStatePath, delayedReasonsList);
      }
    },
  });
}
